import { messages } from '@/lib/i18n/messages'
import { createFileRoute, redirect } from '@tanstack/react-router'
import * as z from 'zod'

const paramsSchema = z.object({
  stockReceiptId: z.coerce.number().int().positive(),
})

/**
 * Legacy project-scoped Receipt detail route — kept alive for old
 * bookmarks/links. Redirects to the new global `/stock-receipts/$stockReceiptId/`
 * editor (DocEditorShell-based, ADR-0003 Iter 2 frontend).
 *
 * The old `ReceiptDetailPage` (PageHeader + ReceiptHeaderCard +
 * ReceiptLinesTable) is no longer rendered here; the new editor still
 * reuses `ReceiptLinesTable` internally.
 */
export const Route = createFileRoute('/projects/$projectId/_layout/receipts/$stockReceiptId')({
  parseParams: paramsSchema.parse,
  stringifyParams: ({ stockReceiptId }) => ({ stockReceiptId: String(stockReceiptId) }),
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/stock-receipts/$stockReceiptId/',
      params: { stockReceiptId: String(params.stockReceiptId) } as never,
    })
  },
  staticData: {
    crumb: (m: { params: { stockReceiptId: number } }) =>
      messages.crumbs.receiptDetail.replace('{id}', String(m.params.stockReceiptId)),
  },
})
